import { Radio, Space } from 'antd'
import React, { useEffect } from 'react'
import * as libCon from "../community-hats-js-library/Constants.js"
import * as locCon from "../LocalConstants.js"
import { StateStoredValue } from '../hooks/GeneralStoreHooks'
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions.js'
import { RefContextLanguage } from '../providers/LanguageProvider'
import { tValue } from '../utils/translationFunctions'



function LocationPicker({ includeAll = true }) {

    const [location, setLocation] = StateStoredValue(locCon.PROJECT_LOCATION)

    const i18n = RefContextLanguage()


    useEffect(() => {

        if (includeAll === false && isNullOrUndefined(location))
            setLocation(libCon.ATF_AHMEDABAD)

    }, [includeAll, location, setLocation])



    return (
        <Radio.Group onChange={(e) => setLocation(e.target.value)} value={location}>
            <Space direction="horizontal">
                {
                    includeAll === true && <Radio style={{ color: "white", fontSize: "14px" }} value={null}>{i18n.t('all')}</Radio>
                }
                <Radio style={{ color: "white", fontSize: "14px" }} value={libCon.ATF_AHMEDABAD}>{tValue(i18n, libCon.ATF_AHMEDABAD)}</Radio>
                <Radio style={{ color: "white", fontSize: "14px" }} value={libCon.ATF_ANAND}>{tValue(i18n, libCon.ATF_ANAND)}</Radio>
                <Radio style={{ color: "white", fontSize: "14px" }} value={libCon.ATF_FIROZABAD}>{tValue(i18n, libCon.ATF_FIROZABAD)}</Radio>
            </Space>
        </Radio.Group>
    )
}

export default LocationPicker